<mat-card class="add-rule-card">
  <mat-card-header>
    <mat-card-title>Add New Routing Rule</mat-card-title>
    <button mat-raised-button (click)="this.addRule.emit()">
      <mat-icon>arrow_back</mat-icon>
      Back to Routing Rules
    </button>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="addRuleForm" (ngSubmit)="onSave()">
      <div class="form-grid">
        <!-- Payment Method -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Payment Method</mat-label>
          <mat-select formControlName="paymentMethod">
            <mat-option *ngFor="let option of paymentMethodOptions" [value]="option.value">
              {{ option.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Target Paypoint -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Target Paypoint</mat-label>
          <mat-select formControlName="targetPaypoint">
            <mat-option *ngFor="let option of paypointOptions" [value]="option.value">
              {{ option.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Minimum Amount -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Minimum Amount</mat-label>
          <input matInput type="number" formControlName="minAmount" placeholder="0.00" />
          <mat-hint>$</mat-hint>
        </mat-form-field>

        <!-- Maximum Amount -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Maximum Amount</mat-label>
          <input matInput type="number" formControlName="maxAmount" placeholder="No limit" />
          <mat-hint>$</mat-hint>
        </mat-form-field>

        <!-- Priority -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Priority</mat-label>
          <input
            matInput
            type="number"
            formControlName="priority"
            placeholder="Enter priority (higher = higher priority)"
          />
        </mat-form-field>
      </div>

      <!-- Optional Validation Message -->
      <div *ngIf="addRuleForm.get('paymentMethod').value === 'card'" class="validation-message">
        <mat-icon>warning</mat-icon>
        <span>{{ ruleValidationMessage }}</span>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button mat-button type="button" (click)="onCancel()">Cancel</button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="isSubmitting || addRuleForm.invalid"
        >
          <mat-icon>save</mat-icon>
          Save Rule
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
